import { useRouteMatch } from 'react-router-dom';

import { FeatureType } from 'common/types';

export const useBestOfWoltRoutes = () => {
  const { params } = useRouteMatch<{ feature: FeatureType; slug: string }>();

  return {
    featureLink: `/${params.feature}/${params.slug}`, // feature root url
    indexLink: `/${params.feature}/${params.slug}/best-of-wolt`, // index route for best of wolt module
  };
};
